import { RecoilState, atom } from "recoil";
import { recoilPersist } from "recoil-persist";
import { ClientRegistration } from "../../Component/Model/Dto/Advisory/ClientRegistration";

const { persistAtom } = recoilPersist();

export const ClientRegistrationAtom: RecoilState<ClientRegistration> = atom<ClientRegistration>({
    key: 'ClientRegistrationAtom',
    default: {
        clientRegistrationId: "",
        clientRegistrationName: ""
    } as ClientRegistration,
    effects_UNSTABLE : [persistAtom]
});